// extracted by mini-css-extract-plugin
module.exports = {"headline":"Greeting_headline__XWL1a","skeleton":"Greeting_skeleton__VwCVk"};